import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    setEmail('');
  };

  return (
    <footer className="bg-[#0F1419] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" viewBox="0 0 1200 600">
          <path
            d="M0 300 Q 300 200, 600 300 T 1200 300"
            stroke="#14B8A6"
            strokeWidth="1"
            fill="none"
            opacity="0.3"
          />
          <circle cx="200" cy="150" r="3" fill="#14B8A6" />
          <circle cx="600" cy="250" r="3" fill="#14B8A6" />
          <circle cx="1000" cy="200" r="3" fill="#14B8A6" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="lg:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/12017643-4802-44d9-bbfe-df1970a1ed6c.png"
              alt="Logo"
              className="h-12 w-auto object-contain mb-6"
            />
            <form onSubmit={handleSubscribe} className="mb-6">
              <div className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="flex-1 px-4 py-2.5 rounded-full bg-transparent border border-gray-600 text-white placeholder-gray-500 focus:border-[#14B8A6] focus:ring-2 focus:ring-[#14B8A6]/20 outline-none transition-all text-sm"
                />
                <button
                  type="submit"
                  className="w-10 h-10 bg-[#FF6B6B] rounded-full flex items-center justify-center hover:bg-[#FF5252] transition-all flex-shrink-0 cursor-pointer"
                >
                  <i className="ri-notification-line text-white"></i>
                </button>
              </div>
            </form>
            <p className="text-2xl font-serif text-gray-300 leading-relaxed">
              Building digital excellence, one website at a time
            </p>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-sm text-[#B4B8C1] hover:text-[#FF6B6B] transition-colors cursor-pointer">
                  Website Design
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-[#B4B8C1] hover:text-[#FF6B6B] transition-colors cursor-pointer">
                  SEO Optimization
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-[#B4B8C1] hover:text-[#FF6B6B] transition-colors cursor-pointer">
                  Performance Analytics
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-[#B4B8C1] hover:text-[#FF6B6B] transition-colors cursor-pointer">
                  Content Strategy
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-6">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="#portfolio" className="text-sm text-[#B4B8C1] hover:text-[#FF6B6B] transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-sm text-[#B4B8C1] hover:text-[#FF6B6B] transition-colors cursor-pointer">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-sm text-[#B4B8C1] hover:text-[#FF6B6B] transition-colors cursor-pointer">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-[#B4B8C1] hover:text-[#FF6B6B] transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-6">Resources</h4>
            <ul className="space-y-3">
              <li>
                <a href="#blog" className="text-sm text-[#B4B8C1] hover:text-[#FF6B6B] transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
              <li>
                <a href="#seo-dashboard" className="text-sm text-[#B4B8C1] hover:text-[#FF6B6B] transition-colors cursor-pointer">
                  SEO Tools
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-[#B4B8C1] hover:text-[#FF6B6B] transition-colors cursor-pointer">
                  Case Studies
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-[#B4B8C1] hover:text-[#FF6B6B] transition-colors cursor-pointer">
                  Support
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <p className="text-sm text-gray-500">
              &copy; 2024 Website Builder & SEO. All rights reserved.
            </p>

            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-lg border border-gray-700 flex items-center justify-center hover:border-[#FF6B6B] hover:text-[#FF6B6B] transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg border border-gray-700 flex items-center justify-center hover:border-[#FF6B6B] hover:text-[#FF6B6B] transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg border border-gray-700 flex items-center justify-center hover:border-[#FF6B6B] hover:text-[#FF6B6B] transition-all cursor-pointer"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg border border-gray-700 flex items-center justify-center hover:border-[#FF6B6B] hover:text-[#FF6B6B] transition-all cursor-pointer"
              >
                <i className="ri-dribbble-fill text-lg"></i>
              </a>
            </div>

            <div className="flex items-center gap-6 text-sm text-gray-500">
              <a href="#" className="hover:text-[#FF6B6B] transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <span className="text-gray-700">|</span>
              <a href="#" className="hover:text-[#FF6B6B] transition-colors cursor-pointer">
                Terms
              </a>
              <span className="text-gray-700">|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF6B6B] transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
